//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { Locales } from '../locales/locale';
import { LocalesFlag } from '../locales/localesFlag';

export type TermsConditionsSettings = Partial<
  Record<Locales, TermsAndConditionsInfo>
>;

export interface TermsAndConditionsInfo {
  url: string;
  fullUrl: string;
  countryFlag: string | undefined;
  label: string;
  retailerMessages: string[];
  tikTokRetailerMessage: string;
}
// Added the tikTokRetailerMessage due to the character limitation of 150

export const termsConditionsSettings: TermsConditionsSettings = {
  [Locales.EN_US]: {
    url: 'https://bv-url.com/vc-tou',
    fullUrl: 'https://www.bazaarvoice.com/legal/terms-of-use/visual-content',
    countryFlag: LocalesFlag[Locales.EN_US],
    label: 'English',
    retailerMessages: [
      'Your agreement allows us to share on our sites and with retailers.',
      'By agreeing, your content could also be used by retailers.',
      'Learn more about sharing with us and retailers.',
      'Your consent allows us to share on our sites and with retailers.',
    ],
    tikTokRetailerMessage: 'Learn more:',
  },

  [Locales.DE_DE]: {
    url: 'https://bv-url.com/de/vc-tou',
    fullUrl:
      'https://www.bazaarvoice.com/de/legal/nutzungsbedingungen-visual-content',
    countryFlag: LocalesFlag[Locales.DE_DE],
    label: 'German',
    retailerMessages: [
      'Ihre Einwilligung ermöglicht und erlaubt uns, Ihren Inhalt auf unserer Website zu veröffentlichen und an Händler in unserem Netzwerk weiterzugeben.',
      'Wenn Sie einwilligen können Ihre Inhalte auch von den Händlern in unserem Netzwerk verwendet werden.',
      'Erfahren Sie mehr darüber, wie Ihre Inhalte mit Ihrer Einwilligung von uns und von den Händlern in unserem Netzwerk genutzt werden.',
      'Mit Ihrer Zustimmung können wir Ihre Inhalte auf unserer Website veröffentlichen und an Händler in unserem Netzwerk weitergeben.',
    ],
    tikTokRetailerMessage: 'Mehr erfahren:',
  },
  [Locales.FR_FR]: {
    url: 'https://bv-url.com/fr/vc-tou',
    fullUrl:
      'https://www.bazaarvoice.com/fr/legal/conditions-dutilisation-des-contenus-visuels',
    countryFlag: LocalesFlag[Locales.FR_FR],
    label: 'French',
    retailerMessages: [
      'Votre accord nous permet de partager des contenus sur nos sites et sur les sites des distributeurs.',
      'En acceptant, votre contenu pourra également être utilisé par les distributeurs.',
      'En savoir plus sur le partage avec notre organisation et les distributeurs.',
      'Votre consentement nous permet de diffuser des contenus sur nos sites et sur les sites des distributeurs.',
    ],
    tikTokRetailerMessage: 'En savoir plus:',
  },
};
